import { UseQueryOptions, useQuery } from 'react-query';
import { RemotePostRepo } from './PostRepo';
import { InfoDetailVO } from '@domain/vo/info/infoDetailVO';

const key = ['post'];
const repo = new RemotePostRepo();

const fetchInfoDetail = async (postSn: number) => {
  const { data } = await repo.fetchInfoDetail(postSn);
  return new InfoDetailVO(data);
};

export const useInfoDetail = (postSn: number, options?: UseQueryOptions) => {
  return useQuery([...key, postSn], () => fetchInfoDetail(postSn), options as any);
};
